/**
 *
 * Asynchronously loads the component for SignUp
 *
 */
import Loadable from "react-loadable";

export default Loadable({
  loader: () => import("./ShowNotification"),
  loading: () => null
});



// WEBPACK FOOTER //
// ./src/components/Notification/LoadableShowNotification.js